import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import { Button } from 'flowbite-react';
import React from 'react';
import { BiEdit, BiPencil } from 'react-icons/bi';
import { HiOutlineDownload } from 'react-icons/hi';
import { PiShareNetworkBold } from 'react-icons/pi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { APP_ENDPOINT } from 'src/config/env.config';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import { copyToClipboard } from 'src/utils/copyToClipboard.utils';
import { sendTrackingEvent } from 'src/utils/gtm';
import { UIUser } from 'types';

const ProfileActions = ({
	isSelf,
	userProfileInfo,
	showBannerBg,
}: {
	isSelf: boolean;
	userProfileInfo: UIUser;
	showBannerBg: boolean;
}) => {
	const toast = useToast();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const company = searchParams.get('company');
	const isMobile = useMediaQuery('(max-width:960px)');
	const PAGE_URL = `${APP_ENDPOINT}/profile/${String(userProfileInfo?.handler)}`;
	const { isRecruiterLoggedIn, isAccountManagerLoggedIn, isUserUniversityManagerLoggedIn } = useUserContext();
	const isPublicProfile =
		company === 'true' || isRecruiterLoggedIn || isAccountManagerLoggedIn || isUserUniversityManagerLoggedIn;

	return (
		<div className="ml-auto flex items-center gap-2">
			{/* These buttons are only visible to the actual profile owner. */}
			{isSelf ? (
				<Button
					as="a"
					size="0"
					color="light"
					className="px-2 md:px-3 py-[6px] md:py-2 text-[8.471px] md:text-xs rounded-[4.235px] md:rounded-[6px] cursor-pointer"
					onClick={() => {
						sendTrackingEvent({
							event: 'profile_edit',
							eventLabel: window.location.pathname,
						});
						navigate('/profile/edit');
					}}
				>
					<BiPencil className="min-w-[11.294px] min-h-[11.294px] md:min-w-[16px] md:min-h-[16px] md:mr-2" />
					<p className="hidden md:block">Edit Profile</p>
				</Button>
			) : null}

			{/* {isSelf && userProfileInfo?.flags?.isMasaiStudent ? (
				<Button
					as="a"
					size="0"
					color="light"
					onClick={() => {
						sendTrackingEvent({
							event: 'pif_profile_edit',
							eventLabel: window.location.pathname,
						});
						navigate('/benchmarking/optional-details');
					}}
					className="px-2 md:px-3 py-[6px] md:py-2 text-[8.471px] md:text-xs rounded-[4.235px] md:rounded-[6px] cursor-pointer"
				>
					<BiEdit className="min-w-[11.294px] min-h-[11.294px] md:min-w-[16px] md:min-h-[16px] md:mr-2" />
					<p className="hidden md:block">Edit PIF Form</p>
				</Button>
			) : null} */}

			<div>
				<Button
					as="a"
					size="0"
					color="light"
					onClick={() => {
						sendTrackingEvent({
							event: 'profile_share',
							eventLabel: window.location.pathname,
						});
						copyToClipboard(PAGE_URL + (isPublicProfile ? '?company=true' : ''));
						toast({
							title: 'Profile link copied successfully',
							type: 'success',
							duration: 10000,
						});
					}}
					className="px-2 md:px-3 py-[6px] md:py-2 text-[8.471px] md:text-xs rounded-[4.235px] md:rounded-[6px] cursor-pointer"
				>
					<PiShareNetworkBold className="min-w-[11.294px] min-h-[11.294px] md:min-w-[16px] md:min-h-[16px] md:mr-2" />
					{!isMobile ? 'Share Profile' : ''}
				</Button>
			</div>

			{userProfileInfo.profile?.resumeLink ? (
				<div>
					<Button
						as="a"
						download={'Resume'}
						href={userProfileInfo.profile?.resumeLink ?? ''}
						target="_blank"
						size="0"
						color="light"
						className="px-2 md:px-3 py-[6px] md:py-2 text-[8.471px] md:text-xs rounded-[4.235px] md:rounded-[6px]"
					>
						<HiOutlineDownload className="min-w-[11.294px] mr-1 min-h-[11.294px] md:min-w-[16px] md:min-h-[16px] md:mr-2" />
						{isMobile ? 'Download' : 'Download Resume'}
					</Button>
				</div>
			) : null}
		</div>
	);
};

export default ProfileActions;
